$(document).ready(function(){

  // collection page 301 redirection
  if (window.location.href === 'https://www.reranger.com/collections/all') {
      // Redirect to the target URL
      window.location.href = 'https://www.reranger.com/collections/shop-all';
  }
  
  $('.riactslider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 100,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true
  });  
  // Duster featured slider-showcase*************
  $('.featured-slide-duster').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    infinite: false,
    autoplaySpeed: 4000
  });
  // Duster shop cards******************
  $('.duster-cards-wrapper').slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  arrows: false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,arrows: true
      }
    }
  ]
  });
  // clearsight nav wrapper slider*******************
   $('.lens-discovery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
     adaptiveHeight: true,
    asNavFor: '.clearsight-thumbnail-nav'
  });
  $('.clearsight-thumbnail-nav').slick({
    slidesToShow: 5,
    infinite: true,
    slidesToScroll: 1,
    asNavFor: '.lens-discovery',
    dots: false,
    arrows: true,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        centerMode: false,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
  });
  // Pro staff lenses slider*****************************
  $('.staff-slider-lenses').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 100,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true
    });  
  // Hide product details if info is empty
  var tableContent = $.trim($('.about-pdp .product-detail table tbody').text());
  if(tableContent.length == 0){
    $('.about-pdp').hide();
  }

  // Profile Opener**************************
  $('.staff-member').click(function(){
    $(this).find('.staff-modal').show();
    $('header').hide();
    $('body').addClass('active-profile-modal');
  });
  $(document).on("click", '.modal-dropper', function(event) { 
    $(this).parent().hide();
    $('header').show();
    $('body').removeClass('active-profile-modal');
  });

  // Footer*****************************
  if ($(window).width() < 900) {
   $('.footer__block-list p.bold').click(function(){
    $(this).parent().toggleClass('menu-open');
    $(this).parent().siblings().removeClass('menu-open');
    $(this).parent().find('ul.v-stack').slideToggle();
    $(this).parent().siblings().find('ul.v-stack').slideUp();
  });
  }

  // Warning text
  $('.warning-trigger').click(function(){
    $(this).find('.ad-open').toggle();
    $(this).find('.ad-close').toggle();
    $(this).next().slideToggle();
  });

  // contact us hide success message after 5 seconds
  setTimeout(function() { $(".contact-form .banner--success").hide(); }, 5000);
  
});